import { useEffect } from 'react';

const getType = (url) => {
  const clean = url.split('?')[0].toLowerCase();
  if (clean.endsWith('.ico')) return 'image/x-icon';
  if (clean.endsWith('.svg')) return 'image/svg+xml';
  return 'image/png';
};

const FaviconUpdater = ({ url }) => {
  useEffect(() => {
    if (!url) return;

    // Remove todos os links de ícone existentes (icon + shortcut icon)
    // para forçar o browser a reavaliar o favicon da aba.
    document
      .querySelectorAll("link[rel='icon'], link[rel='shortcut icon']")
      .forEach((el) => el.remove());

    const link = document.createElement('link');
    link.rel = 'icon';
    link.type = getType(url);
    link.href = url;
    document.head.appendChild(link);
  }, [url]);

  return null;
};

export default FaviconUpdater;
